import { useRecoilState } from "recoil";
import { attendanceDateState } from "../../utils/atoms/atoms";
import { capitalizeFirstLetter } from "../../utils/funcs/common";
import { AttendanceFilter } from "../../interfaces/app_types";

const AttendanceDateFilter = ({ attdDate }: AttendanceFilter) => {
  const [attendanceDate, setAttendanceDate] =
    useRecoilState(attendanceDateState);
  return (
    <div
      className={
        attendanceDate === attdDate
          ? " styled-btn--dark mobile-btn-style"
          : "styled-btn--std mobile-btn-style"
      }
      onClick={() => setAttendanceDate(attdDate)}
    >
      {capitalizeFirstLetter(attdDate)}
    </div>
  );
};

export default AttendanceDateFilter;
